import office from '@/taskpane/officejs/office-wrapper'
import CallbackArgs, { defaultCallbackArgs } from '../messages/callback-args'
import MessageArgs from '../messages/message-args'
import sendMessageToSidebar from '../messages/send-message-to-sidebar'

interface SidebarLoginRequestedArgs extends MessageArgs {
  loginUrl: string
}

interface SidebarLoginRequestedCallbackArgs extends CallbackArgs {
  success: boolean
}

interface SsoAuthCompletedArgs {
  code: string
}

export default async function sidebarLoginRequestedHandler(data: SidebarLoginRequestedArgs) {
  const callbackArgs = defaultCallbackArgs() as SidebarLoginRequestedCallbackArgs

  try {
    const loginRedirect = window.location.origin + '/login.html'
    const dialogOptions: Office.DialogOptions = {
      width: Math.floor((100 * 750) / screen.width),
      height: Math.floor((100 * 600) / screen.height),
      displayInIframe: false,
      promptBeforeOpen: false,
    }

    if (!supportsDialogMessaging()) {
      localStorage.setItem('redirectUrl', data.loginUrl)
    }

    const officeDialog = await office.ui.displayDialog(loginRedirect, dialogOptions)
    officeDialog.addEventHandler(Office.EventType.DialogMessageReceived, processOfficeDialogEvent(data, officeDialog))

    callbackArgs.success = !!officeDialog
  } catch {
    callbackArgs.success = false
  } finally {
    sendMessageToSidebar('SidebarLoginRequestedCallback', callbackArgs)
  }
}

function processOfficeDialogEvent(data: SidebarLoginRequestedArgs, dialog: Office.Dialog) {
  return function (args) {
    // the sidebar and login popup communicate through the Office Dialog API
    const messageObj = JSON.parse(args.message)

    if (messageObj.messageType == 'registeredHandlers') {
      // this message will be sent once the addHandlerAsync is set up in login.html asking for the login Url
      const messageObject = { messageType: 'redirectUrl', redirectUrl: data.loginUrl }
      dialog.messageChild(JSON.stringify(messageObject))
    } else {
      // any other message would be sent from login-callback.html once login process is complete
      if (messageObj.message) {
        sendMessageToSidebar('Error', { errorMessage: messageObj.message } as CallbackArgs)
      } else {
        sendMessageToSidebar('SsoAuthCompleted', { code: messageObj.code } as SsoAuthCompletedArgs)
      }

      dialog.close()
    }
  }
}

function supportsDialogMessaging() {
  return Office.context.requirements.isSetSupported('DialogApi', '1.2')
}
